import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 no-underline"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
          {article.title}
        </h3>
        <p className="text-foreground-600 text-sm line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
          </div>
          <span className="flex items-center gap-1 text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
            阅读更多
            <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}